import { runInAction } from 'mobx';
import { types as t } from 'mst-effect';
import { withRunInAction } from 'utils/withRunInAction';

export interface InputTypeFilter {
  id: string;
}

export const InputsTypeFiltersStore = t
  .compose(
    withRunInAction(),
    t.model('InputsTypeFiltersStore', {
      inputTypeFilters: t.array(
        t.model({
          id: t.string,
        }),
      ),
    }),
  )
  .actions((self) => ({
    clearInputTypeFilters() {
      runInAction(() => {
        self.inputTypeFilters.replace([]);
      });
    },

    getInputsTypeFilter(inputTypeId: string) {
      return self.inputTypeFilters.find(({ id }) => id === inputTypeId);
    },

    addInputsTypeFilters(filter: InputTypeFilter) {
      self.inputTypeFilters.push(filter);
    },
  }));
